import React, { useEffect, useState } from "react";
import { useLang } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "ap_cookies_v1";

export default function CookieBanner() {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // small delay so the banner doesn't fight the hero animation
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* storage unavailable — banner will just be dismissed for this session */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-[460px] z-[80] bg-navy text-ivory shadow-2xl border border-ivory/10"
      role="dialog"
      aria-live="polite"
      aria-label={lang === "fr" ? "Cookies" : "Cookies"}
    >
      <div className="p-5 md:p-6 relative">
        <button
          onClick={accept}
          aria-label={lang === "fr" ? "Fermer" : "Close"}
          className="absolute top-3 right-3 text-ivory/40 hover:text-ivory transition-colors"
        >
          <X size={14} />
        </button>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand mb-2">
          — {lang === "fr" ? "Cookies" : "Cookies"}
        </div>
        <p className="text-xs leading-relaxed text-ivory/85">
          {lang === "fr"
            ? "Ce site n'utilise que des cookies strictement nécessaires à l'authentification dans l'espace confidentiel. Aucun cookie publicitaire ni de mesure d'audience tiers."
            : "This site only uses strictly necessary cookies for authentication in the confidential workspace. No advertising or third-party analytics cookies."}
        </p>
        <div className="mt-4 flex items-center gap-4">
          <button
            onClick={accept}
            data-testid="cookie-accept"
            className="inline-flex items-center gap-2 bg-brand hover:bg-brandDark text-white px-4 py-2 text-[10px] tracking-[0.22em] uppercase font-mono transition-colors"
          >
            {lang === "fr" ? "J'ai compris" : "Got it"}
          </button>
          <Link
            to="/rgpd"
            data-testid="cookie-rgpd-link"
            className="text-[10px] tracking-[0.22em] uppercase font-mono text-ivory/70 hover:text-ivory underline underline-offset-4 decoration-ivory/30 transition-colors"
          >
            {lang === "fr" ? "En savoir plus" : "Learn more"}
          </Link>
        </div>
      </div>
    </div>
  );
}
